import "reflect-metadata";
import { container, type InjectionToken } from "tsyringe";
import { configure } from "../lib/vvm";
import { WarehouseApi, WAREHOUSE_API_TOKEN } from "../api/WarehouseApi";
import { Navigation, NAVIGATION_STORE_TOKEN } from "../stores/navigation";
import { RealtimeStore, REALTIME_STORE_TOKEN } from "../stores/RealtimeStore";
import { SettingsStore, SETTINGS_STORE_TOKEN } from "../stores/SettingsStore";
import {
  BROWSER_NOTIFICATIONS_STORE_TOKEN,
  BrowserNotificationsStore,
} from "../stores/BrowserNotificationsStore";
import {
  DATA_STORAGE_FACTORY_TOKEN,
  DefaultDataStorageFactory,
  STORAGE_READ_FACADE_TOKEN,
  StorageReadFacade,
} from "../api/storage";
import { Store, STORE_TOKEN } from "../stores/store";
import { UIStore, UI_STORE_TOKEN } from "../stores/UIStore";

let isConfigured = false;

function registerSingletonOnce<T>(
  token: InjectionToken<T>,
  cls: new (...args: never[]) => T,
): void {
  if (!container.isRegistered(token)) {
    container.registerSingleton(token, cls);
  }
}

export function setupMvvmDi(): void {
  if (isConfigured) {
    return;
  }

  registerSingletonOnce(UI_STORE_TOKEN, UIStore);
  registerSingletonOnce(SETTINGS_STORE_TOKEN, SettingsStore);
  registerSingletonOnce(NAVIGATION_STORE_TOKEN, Navigation);
  registerSingletonOnce(REALTIME_STORE_TOKEN, RealtimeStore);
  registerSingletonOnce(STORE_TOKEN, Store);
  registerSingletonOnce(WAREHOUSE_API_TOKEN, WarehouseApi);
  registerSingletonOnce(DATA_STORAGE_FACTORY_TOKEN, DefaultDataStorageFactory);
  registerSingletonOnce(STORAGE_READ_FACADE_TOKEN, StorageReadFacade);
  registerSingletonOnce(
    BROWSER_NOTIFICATIONS_STORE_TOKEN,
    BrowserNotificationsStore,
  );

  configure({
    vmFactory: (VM) => container.resolve(VM),
  });

  isConfigured = true;
}
